<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import ToggleSwitch from 'dashboard/components-next/switch/Switch.vue';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { PAGE_GUIDE_HIDDEN_KEY } from 'dashboard/components-next/teletel/pageGuide/pageGuides';

// Per-user switch for the floating «page guide» launcher. Stored in the
// user's ui_settings (same store as font size and editor hotkey), so the
// choice follows the user across browsers. Default: shown.
const { t } = useI18n();
const { uiSettings, updateUISettings } = useUISettings();

const isShown = computed({
  get: () => uiSettings.value?.[PAGE_GUIDE_HIDDEN_KEY] !== true,
  set: shown => updateUISettings({ [PAGE_GUIDE_HIDDEN_KEY]: !shown }),
});
</script>

<template>
  <div class="flex gap-2 justify-between w-full items-start">
    <div>
      <label class="text-n-gray-12 font-medium leading-6 text-sm">
        {{ t('PROFILE_SETTINGS.FORM.INTERFACE_SECTION.PAGE_GUIDE.TITLE') }}
      </label>
      <p class="text-n-gray-11">
        {{ t('PROFILE_SETTINGS.FORM.INTERFACE_SECTION.PAGE_GUIDE.NOTE') }}
      </p>
    </div>
    <div class="flex items-center gap-2 mt-1 shrink-0">
      <span class="text-sm text-n-slate-11">
        {{
          isShown
            ? t('PROFILE_SETTINGS.FORM.INTERFACE_SECTION.PAGE_GUIDE.SHOWN')
            : t('PROFILE_SETTINGS.FORM.INTERFACE_SECTION.PAGE_GUIDE.HIDDEN')
        }}
      </span>
      <ToggleSwitch v-model="isShown" />
    </div>
  </div>
</template>
